<template>
    <v-container 
        fluid 
        class="offers"
    >
        <v-row justify="center" align="center">
            <v-col justify="center" align="center" cols=2>
                {{type}} 
                <v-icon
                    medium
                    color="#ad282d"
                >
                    mdi-percent-outline
                </v-icon>
            </v-col>
            <v-col justify="center" align="center" cols=10>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row justify="left" align="center">
            <v-col 
                v-for="(offer, index) in offers"
                :key="index" 
                justify="center" 
                align="center" 
                xs="12" sm="12" md="6" lg="3" 
            >
                <v-card
                    class="mx-auto"
                    min-width="300px"
                    min-height="150px"
                    outlined
                >
                    <v-list-item three-line>
                    <v-list-item-content>
                        <div class="text-overline mb-2">
                        {{offer.partner.title}}
                        </div>
                        <v-list-item-title class="text-h7 mb-5">
                        {{offer.description}}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                        έως {{formatDate(offer)}}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-icon
                        medium
                        color="#ad282d"
                    >
                        mdi-tag
                    </v-icon>
                    </v-list-item>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
  import restApi from "@/rest-api";

  export default {
    props: { 
        type: String ,
        offers: Array
    },
    data() {
        return {
        }
    },
    created() {
        if(this.offers.length === 0){
            this.getOffersByType(this.type);
        }
    },
    methods: {
      getImage() {
        return require('@/assets/LOGOPARON 2023.png')
      },
      formatDate(offer) {
        var date = new Date(offer.expirationDate)
        return date.getDate()+
          "/"+(date.getMonth()+1)+
          "/"+date.getFullYear();
      },
      getOffersByType() {
        var filter = {
            "type": this.type,
            "active": true,
            "secret": false
        }
        var search = `/offer/filtered`
        restApi
        .post(search, filter)
        .then(response => {
            this.offers = response.data;
        })
        .catch((error) => {
            console.log(error);
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
    @media only screen and (min-width: 600px){
        .offers{
            width: 90%;
            height: auto;
            margin-bottom: 7%;
        }
    }

    @media only screen and (max-width: 600px){
        .offers{
            margin-top: 20%;
            width: 90%;
            height: auto;
            margin-bottom: 20%;
        }
    }

    .title{
        text-align:center;
        font-weight:normal;
        margin-top: 3%;
        margin-bottom: 2%;
        font-size: 3vh!important;
    }

    .theme--light.v-divider {
      border-color: rgb(0 0 0);
    }

    .v-divider--vertical {
      border-width: 300px thin 100px 0;
  }
  .v-list-item__title, .v-list-item__subtitle {
    white-space: break-spaces!important;
  }
</style>